"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setHasEndingTrackingData = exports.resetChangelogData = exports.getTrackingError = exports.getTrackingDataSuccess = exports.getTrackingData = exports.trackingSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    trackData: [],
    isTrackingLoading: false,
    hasTrackingError: false,
    trackingSuccess: false,
    hasEndingTrackingData: false,
};
exports.trackingSlice = (0, toolkit_1.createSlice)({
    name: "tracking",
    initialState,
    reducers: {
        getTrackingData: (state) => {
            state.isTrackingLoading = true;
        },
        getTrackingDataSuccess: (state, action) => {
            const newTrackData = [...state.trackData, ...action.payload];
            state.isTrackingLoading = false;
            state.hasTrackingError = false;
            state.trackingSuccess = true;
            state.trackData = newTrackData;
        },
        setHasEndingTrackingData: (state) => {
            state.hasEndingTrackingData = true;
        },
        getTrackingError: (state) => {
            state.isTrackingLoading = false;
            state.hasTrackingError = true;
        },
        resetChangelogData: (state) => {
            state.trackData = initialState.trackData;
            state.hasEndingTrackingData = false;
        },
    },
});
_a = exports.trackingSlice.actions, exports.getTrackingData = _a.getTrackingData, exports.getTrackingDataSuccess = _a.getTrackingDataSuccess, exports.getTrackingError = _a.getTrackingError, exports.resetChangelogData = _a.resetChangelogData, exports.setHasEndingTrackingData = _a.setHasEndingTrackingData;
exports.default = exports.trackingSlice.reducer;
